import React, { memo, useState } from "react";
import { Modal } from "@shopify/polaris";
import intl from "../../../../i18n/intl";
import { reqPostUpdateOrderBatchSourcing } from "../../../../api";

const ArchiveOrderModal = memo(
  ({ bulkSourceData, setBulkSourceData,getPageData,toastFun }) => {
    const [loading,setLoading] = useState(false);
    const handleArchiveConfigRequest = async () => {
      setLoading(true)
      // 接口请求
       const params = {
            shopify_order_ids: bulkSourceData?.ids.join(','),
          };
          try {
            const response = await reqPostUpdateOrderBatchSourcing(params);
            if (response.code === "200") {
              setBulkSourceData({
                open: false,
                applyLoading: false,
                isBulk: true,
                sourcingTip:false,
                ids: [],
              });
              getPageData(true)
              toastFun('Sourcing Request Sent')
            } else {
              toastFun('Sourcing failed')
            }
            setLoading(false)
          } catch (error) {
            
          }
       
    };
    return (
      <div>
        <Modal
          open={bulkSourceData.open}
          onClose={() => {
            setBulkSourceData({
              open: false,
              applyLoading: false,
              isBulk: true,
              sourcingTip:false,
              ids: [],
            });
          }}
          title={
            bulkSourceData.isBulk
              ? "Bulk order sourcing"
              : "Order Sourcing Request"
          }
          primaryAction={{
            content: intl.get("Apply"),
            onAction: handleArchiveConfigRequest,
            loading: loading,
          }}
          secondaryActions={[
            {
              content: intl.get("Cancel"),
              onAction: () => {
                setBulkSourceData({
                  open: false,
                  applyLoading: false,
                  isBulk: true,
                  sourcingTip:false,
                  ids: [],
                });
              },
            },
          ]}
        >
          <Modal.Section>
           {bulkSourceData.isBulk ? <p>
              {intl.get(
                `Are you sure you want to source the selected ${
                  bulkSourceData.ids.length
                } ${
                  bulkSourceData.ids.length > 1 ? "orders" : "order"
                }? Once confirmed, we'll start sourcing for the pending sourcing orders.`
              )}
            </p>:
            <p>
              {intl.get(
                "Are you sure you want to source the order? Once confirmed, we'll start sourcing for the await sourcing sku."
              )}
            </p>}
          </Modal.Section>
        </Modal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
